var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-wrapper"},[_c('img',{staticClass:"user-ava",attrs:{"src":_vm.src,"alt":""}}),_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }